import { StorageError } from "@/infrastructure/errors/StorageError";

export class SessionStorageManager {
  private readonly prefix: string;

  constructor(prefix: string = "irAppAdmin") {
    this.prefix = prefix;
  }

  private getKey(key: string): string {
    return this.prefix ? `${this.prefix}:${key}` : key;
  }

  get(key: string): string | null {
    try {
      return sessionStorage.getItem(this.getKey(key));
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to retrieve data from sessionStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to retrieve data from sessionStorage: Unknown error");
      }
    }
  }

  set(key: string, value: string): void {
    try {
      sessionStorage.setItem(this.getKey(key), value);
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to set data in sessionStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to set data in sessionStorage: Unknown error");
      }
    }
  }

  delete(key: string): void {
    try {
      sessionStorage.removeItem(this.getKey(key));
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to delete data from sessionStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to delete data from sessionStorage: Unknown error");
      }
    }
  }

  clear(): void {
    try {
      sessionStorage.clear();
    } catch (error) {
      if (error instanceof Error) {
        throw new StorageError(`Failed to clear sessionStorage: ${error.message}`);
      } else {
        throw new StorageError("Failed to clear sessionStorage: Unknown error");
      }
    }
  }
}